const actions = {
    FETCH_PREDICTED_GRADES: 'FETCH_PREDICTED_GRADES',
    FETCH_PREDICTED_GRADES_RESET: 'FETCH_PREDICTED_GRADES_RESET',

    // Report Action Types
    FETCH_PREDICTED_GRADES_REPORT: 'FETCH_PREDICTED_GRADES_REPORT',
    FETCH_SINGLE_STUDENT_PREDICTED_GRADE_TRANSCRIPT: 'FETCH_SINGLE_STUDENT_PREDICTED_GRADE_TRANSCRIPT',

    fetchPredictedGradesAction: (data) => {
        return {
            type: actions.FETCH_PREDICTED_GRADES,
            data: data
        };
    },

    fetchPredictedGradesReportAction: (data) => {
        return {
            type: actions.FETCH_PREDICTED_GRADES_REPORT,
            data: data
        };
    },

    fetchSingleStudentPredictedGradeTranscriptAction: (data) => {
        return {
            type: actions.FETCH_SINGLE_STUDENT_PREDICTED_GRADE_TRANSCRIPT,
            data: data
        };
    },

    resetFetchPredictedGradesFromAction: (data) => {
        return {
            type: actions.FETCH_PREDICTED_GRADES_RESET,
            data: data
        };
    },
};

export default actions;